import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { ITeamFilterModel } from "shared/pages/teams/types";

export enum FilterOrManual {
    FILTER = 'filter', // FILTER = обыч запрос
    MANUAL = 'manual'   // manual = проекты без фильтра по тегам и только projectIds параметр
}

const TAG_KEYS = ['tags', 'requiredTags', 'ownerTags', 'exceptedTags', 'tagIds', 'requiredTagIds', 'ownerTagIds', 'exceptedTagIds'] as const;

export const sanitizeTeamFilterForSelectionMode = (filter: ITeamFilterModel, usingFilterOrManual: boolean): ITeamFilterModel => {
    if (usingFilterOrManual) {
        return { ...filter, usingFilterOrManual: true, projectIds: [] };
    }
    const next = { ...filter, usingFilterOrManual: false, projectIds: filter.projectIds ?? [] };
    TAG_KEYS.forEach((key) => { delete next[key]; });
    return next;
}

export const sanitizeFilterForGrid = (filter: any, moderationType: unknown): any => {
    if (!filter || moderationType !== ModerationType.Outer || !('usingFilterOrManual' in filter)) {
        return filter;
    }
    return sanitizeTeamFilterForSelectionMode(filter, !!filter.usingFilterOrManual);
}

export const sanitizeTabForSelectionMode = (tab: any, usingFilterOrManual: boolean): any => {
    const nextFilter = sanitizeTeamFilterForSelectionMode(tab.filter, usingFilterOrManual);
    if (!usingFilterOrManual) {
        return { ...tab, filter: nextFilter };
    }
    return {
        ...tab,
        filter: nextFilter,
        customSorting: false,
        customProjectSorting: undefined,
        customTeamsSorting: undefined,
    };
}

export const getFilterOrManual = (moderationType: ModerationType, filter: ITeamFilterModel) => {
    const { isChannel } = isTeamChannel(moderationType)

    if (isChannel) return FilterOrManual.MANUAL
    if (moderationType === ModerationType.Outer) {
        return !!filter?.usingFilterOrManual ? FilterOrManual.FILTER : FilterOrManual.MANUAL
    }

    return FilterOrManual.FILTER
}
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { ITeamFilterModel } from "shared/pages/teams/types";

export enum FilterOrManual {
    FILTER = 'filter', // FILTER = обыч запрос
    MANUAL = 'manual'   // manual = проекты без фильтра по тегам и только projectIds параметр
}

const TAG_KEYS = ['tags', 'requiredTags', 'ownerTags', 'exceptedTags', 'tagIds', 'requiredTagIds', 'ownerTagIds', 'exceptedTagIds'] as const;

export const sanitizeTeamFilterForSelectionMode = (filter: ITeamFilterModel, usingFilterOrManual: boolean): ITeamFilterModel => {
    if (usingFilterOrManual) {
        return { ...filter, usingFilterOrManual: true, projectIds: [] };
    }
    const next = { ...filter, usingFilterOrManual: false, projectIds: filter.projectIds ?? [] };
    TAG_KEYS.forEach((key) => { delete next[key]; });
    return next;
}

export const sanitizeFilterForGrid = (filter: any, moderationType: unknown): any => {
    if (!filter || moderationType !== ModerationType.Outer || !('usingFilterOrManual' in filter)) {
        return filter;
    }
    return sanitizeTeamFilterForSelectionMode(filter, !!filter.usingFilterOrManual);
}

export const sanitizeTabForSelectionMode = (tab: any, usingFilterOrManual: boolean): any => {
    const nextFilter = sanitizeTeamFilterForSelectionMode(tab.filter, usingFilterOrManual);
    if (!usingFilterOrManual) {
        return { ...tab, filter: nextFilter };
    }
    return {
        ...tab,
        filter: nextFilter,
        customSorting: false,
        customProjectSorting: undefined,
        customTeamsSorting: undefined,
    };
}

export const getFilterOrManual = (moderationType: ModerationType, filter: ITeamFilterModel) => {
    const { isChannel } = isTeamChannel(moderationType)

    if (isChannel) return FilterOrManual.MANUAL
    if (moderationType === ModerationType.Outer) {
        return !!filter?.usingFilterOrManual ? FilterOrManual.FILTER : FilterOrManual.MANUAL
    }

    return FilterOrManual.FILTER
}
